
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NumberOfApprovalDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-numberofapproval',
  templateUrl: './numberofapproval.component.html',
  styleUrls: ['./numberofapproval.component.scss']
})
export class NumberofapprovalComponent {

  numberofapprovalForm: FormGroup;
  numberofapprovalFormArray: FormGroup;
  control = new FormControl();
  @Input() numberofapprovals: NumberOfApprovalDto[];
  @Input() routeAnimationsElements: any;
  @Output() numberofapproval = new EventEmitter<NumberOfApprovalDto[]>()
  @Output() deleteNumberOfApprovalEvent = new EventEmitter<any>()

    selectedNumberOfApproval: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createNumberOfApprovalForm();
    }

    createNumberOfApprovalForm() {
      this.numberofapprovalForm = this.fb.group({
        NoOfApproval: [0, Validators.required],
        id: null
        });
        this.numberofapprovalFormArray = this.fb.group({ NumberOfApprovals: this.fb.array([])
          });
        this.setNumberOfApproval();
    }

  // method to display numberofapprovals
  setNumberOfApproval() {
    const control  = this.numberofapprovalFormArray.controls.NumberOfApprovals as FormArray;
    this.numberofapprovals.forEach( e => {
      control.push(
        this.fb.group(e)
      );
    });
  }


  // method to add NumberOfApproval
  addNumberOfApproval(value: NumberOfApprovalDto) {
    const control  = this.numberofapprovalFormArray.controls.NumberOfApprovals as FormArray;
    control.insert(0,
          this.fb.group(value)
       );
  }

  selectNumberOfApproval(value) {}
  // method to delete numberofapproval from arrary list
  deleteNumberOfApproval(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.numberofapprovalFormArray.controls.NumberOfApprovals as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.numberofapprovals.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.numberofapprovals[i].id);
         }
      }
    }

  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: NumberOfApprovalDto) {
    if(this.numberofapprovalForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.numberofapprovalFormArray.get('NumberOfApprovals')['controls'][this.selectedIndex].patchValue({NoOfApproval: formValue.NoOfApproval});
    } else {
      if(!!this.numberofapprovals.length) {
        return Swal.fire(
          'Warning!',
          'Please, you cannot add more dan one appproval',
          'warning'
        );
      } else {
      this.addNumberOfApproval(formValue);
      }

    }
    this.selectedIndex = null;
    this.numberofapprovalForm.reset()
  }

  onEdit(index, value: NumberOfApprovalDto) {
    this.selectedIndex = index;
    this.numberofapprovalForm.patchValue({NoOfApproval: value.NoOfApproval});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.numberofapprovalForm.reset();
  }

  onSubmit(formValue: NumberOfApprovalDto[]) {
  this.numberofapproval.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteNumberOfApprovalEvent.emit(this.filteredDelete);
  }
  }

}
